import React, { useState } from 'react';
import { multiFactor } from 'firebase/auth';
import { Shield } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useTenant } from '../../contexts/TenantContext';
import MFASetupFlow from './MFASetupFlow';

export default function MFARequiredGate({ children }) {
  const { currentUser } = useAuth();
  const { clientConfig, isSTX, tenantLoading } = useTenant();
  const [enrolled, setEnrolled] = useState(
    () => currentUser ? multiFactor(currentUser).enrolledFactors.length > 0 : false
  );

  if (tenantLoading) return null;

  // STX users have personal 2FA choice — never forced
  // Client users only gated if client has mandatory 2FA configured
  const mustEnroll =
    !isSTX &&
    clientConfig?.mfa?.enabled === true &&
    clientConfig?.mfa?.mode === 'mandatory' &&
    !enrolled;

  if (!mustEnroll) return children;

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-50">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-sm p-8">
        <div className="flex justify-center mb-5">
          <div className="w-12 h-12 bg-teal-50 rounded-full flex items-center justify-center">
            <Shield size={22} className="text-teal-600" aria-hidden="true" />
          </div>
        </div>
        <h1 className="text-xl font-bold text-gray-900 text-center mb-2">
          Two-factor authentication required
        </h1>
        <p className="text-sm text-gray-700 text-center mb-6">
          Your organisation requires 2FA. Set it up now to access the portal.
        </p>
        <MFASetupFlow onComplete={() => setEnrolled(true)} />
      </div>
    </div>
  );
}
